import {CompetitionStandingsPageRouteMetaDataModel} from "./competition-standings-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitionPageRouteConfig} from "../../../models/competition.page-route.config";

export class CompetitionStandingsPageRouteConfig extends CompetitionPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITION.standings,
      path: `standings`,
      componentImport: () => import("../components/competition-standings-page" /* webpackChunkName: "competition-standings-page" */),
      metadataType: CompetitionStandingsPageRouteMetaDataModel
    });
  }
}